import React from 'react';

function Stats({ stats }) {
  // Return null or loading state if stats is not available
  if (!stats) {
    return (
      <div className="stats">
        <div className="stat-card">
          <h3>Loading...</h3>
          <div className="value">-</div>
        </div>
      </div>
    );
  }

  const percentage = stats.total_courses > 0 
    ? ((stats.parsed / stats.total_courses) * 100).toFixed(1)
    : 0;

  return (
    <div className="stats">
      <div className="stat-card">
        <h3>Total Courses</h3>
        <div className="value">{stats.total_courses ? stats.total_courses.toLocaleString() : 0}</div>
      </div>
      <div className="stat-card">
        <h3>Parsed</h3>
        <div className="value">{stats.parsed ? stats.parsed.toLocaleString() : 0}</div>
        <div style={{ fontSize: '14px', color: '#666' }}>{percentage}%</div>
      </div>
      <div className="stat-card">
        <h3>Approved</h3>
        <div className="value">{stats.approved ? stats.approved.toLocaleString() : 0}</div>
      </div>
      <div className="stat-card">
        <h3>Pending Review</h3>
        <div className="value">{stats.pending ? stats.pending.toLocaleString() : 0}</div>
      </div>
    </div>
  );
}

export default Stats;
